<template>
  <div class=" w-full fixed top-0 flex flex-row items-center justify-center bg-black ">
    <div class="absolute left-4 z-50" >
      <img @click="onClickShowMenu" src="@/assets/icons/v2/icon_nico_menu.svg"
          style="width:24px;height:24px;object-fit: contain"
      />
    </div>


    <van-image v-if="brandImage" class="brand-logo " fit="contain"
        :src="brandImage"/>
    <van-image v-else fit="contain" class="brand-logo" :src="require('@/assets/icons/nico/ic_zofi.svg')"/>

    <!-- 左侧菜单Popup -->
    <van-popup
        class="menu-popup"
        :value="showMenuPopup"
        @input="onShowMenuChange"
        position="left"
        get-container="#app"
        :style="{ height: '100%', width: '73%',background: 'black',color:'white' }"
    >
      <div class="menu-header">
        <div class="flex flex-row" @click="onAppSetting">
          <van-image :src="userInfo.picture" width="48" height="48" round fit="cover"/>
          <div class="flex flex-col  ml-3" style="font-size:12px">
            <div class="flex flex-row items-center ">
              <span>{{ userInfo.nickName }}</span>
              <img src="@/assets/icons/v2/right_arrow.png" style="margin-left:10px;width:15px;height:20px"/>
            </div>
            <span class="third-color">{{ userInfo.email }}</span>
          </div>
        </div>
        <div class="flex flex-col mt-6">
          <van-cell v-for="(item,index) in menus"
              :key="index"
              :value="item.name"
              :icon="item.icon"
              @click="item.action"
              size="large"
              is-link>
          </van-cell>
        </div>
      </div>
      <div class="w-full fixed bottom-10 text-center">
        <div @click="showLogoutPopup = true"
            class="radius-border ml-4 mr-4 h-10 leading-10 text-white text-14px">Logout
        </div>
      </div>

      <DialogTips v-model="showLogoutPopup" left-text="Cancel" right-text="Logout" show-left
          @onLeftClick="showLogoutPopup = false"
          title="Tips"
          parent="#app"
          message="Are you sure you want to exit the currently logged in account?"
          @onRightClick="onLogout"/>
    </van-popup>

  </div>
</template>


<script>
import { mapState } from "vuex";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import { TOKEN } from "@/config/http-json";
import log from "@/util/log";
import userMixin from "@/mixins/userMixin";
import DialogTips from "@/components/DialogTips.vue";
import { openExternalUrl } from "@/util/utils";

export default {
  name: "NicoHeader",
  components: { DialogTips },
  mixins: [userMixin],
  props: {
    modelType: {
      type: [Number, String],
      default: 0
    },
    brandImage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showMenuPopup: false,
      showLogoutPopup: false
    };
  },
  methods: {
    onAppSetting() {
      this.$router.push("AppSettings");
      this.showMenuPopup = false;
    },
    onClickShowMenu() {
      this.showMenuPopup = !this.showMenuPopup;
    },
    onMyCurveListClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        this.$router.push({
          name: "Favorite",
          query: {
            modelType: this.modelType
          }
        });
      });
    },
    onAllHistoryClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        this.$router.push({
          name: "History",
          query: {
            modelType: this.modelType
          }
        });
      });
    },
    onServiceCenterClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        this.$router.push("/omni-assistant");
      });
    },
    onCustomizationClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        this.$router.push("/customization");
      });
    },
    onMyDeviceClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        this.$router.push("/mydevices");
      });

    },
    onNotificationClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        this.$router.push("/notifications");
      });

    },
    onCommunityClick() {
      this.showMenuPopup = false;
      this.$nextTick(() => {
        openExternalUrl("https://www.zofo.com/");
      });
    },
    onShowMenuChange(e) {
      this.showMenuPopup = e;
    },
    async onLogout() {
      await this.$store.dispatch("user/logout");
      this.showLogoutPopup = false;
      this.showMenuPopup = false;
    }
  },
  computed: {
    ...mapState(["brandInfo"]),
    ...mapState("user", ["userInfo"]),
    hasCacheBrandIcon() {
      if (this.brandInfo && this.brandInfo.supplierId !== 749 && this.brandInfo.brandCover) {
        return true;
      }
      return false;
    },

    menus() {
      if (this.isBrandUser) {
        return [
          {
            icon: require("@/assets/icons/v2/icon_my_curve_list_white.svg"),
            name: "My Curve List",
            action: this.onMyCurveListClick
          },
          {
            icon: require("@/assets/icons/v2/icon_all_history_white.svg"),
            name: "All History",
            action: this.onAllHistoryClick
          },
          {
            icon: require("@/assets/icons/v2/icon_server_center_white.svg"),
            name: "Service Center",
            action: this.onServiceCenterClick
          },
          {
            icon: require("@/assets/icons/v2/icon_customization_white.svg"),
            name: "Customization",
            action: this.onCustomizationClick
          }
        ];
      }
      return [
        {
          icon: require("@/assets/icons/consumer/ic_my_devices_white.svg"),
          name: "My Devices",
          action: this.onMyDeviceClick
        },
        {
          icon: require("@/assets/icons/v2/icon_all_history_white.svg"),
          name: "All History",
          action: this.onAllHistoryClick
        },
        {
          icon: require("@/assets/icons/v2/icon_my_curve_list_white.svg"),
          name: "My Curve List",
          action: this.onMyCurveListClick
        },
        {
          icon: require("@/assets/icons/consumer/ic_my_notification_white.svg"),
          name: "Notifications",
          action: this.onNotificationClick
        },
        {
          icon: require("@/assets/icons/consumer/ic_community_white.svg"),
          name: "Community",
          action: this.onCommunityClick
        }
      ];
    }
  }
};
</script>

<style scoped lang="less">
header {
  z-index: 2000;
}

.menu-header {
  padding: 20px;
  margin-top: 1.5rem;
  background: black;
}

.van-cell {
  background: black;
  color: white;
}

.van-cell__left-icon {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 16px;
}

.van-cell__value {
  font-size: 14px;
  color: white;
}

.van-icon__image {
  width: 100%;
  height: 100%;
}

.van-icon-arrow:before {
  color: #CCCCCC;
}

.van-cell--large {
  padding: 20px 0;

  &::after {
    border-bottom: none;
  }
}

.brand-logo {
  padding: 10px 0;
  height: 68px;
}
</style>